import React from 'react'

const Settings = () => {
  return (
    <div className='settings'>Settings</div>
  )
}

export default Settings